import { createClient } from '@/prismicio';
import { notFound } from 'next/navigation';
import { SliceZone } from '@prismicio/react';
import { components } from '@/slices';
import { Modal } from '../common/Modal';
import { GET_STARTED_HOME_UID } from '@/utils';

export const GetStartedModal = async () => {
  const client = createClient();

  const {
    data: { slices },
  } = await client
    .getByUID('get_started', GET_STARTED_HOME_UID)
    .catch(() => notFound());

  return (
    <Modal>
      <SliceZone slices={slices} components={components} />
    </Modal>
  );
};
